module.exports = __webpack_public_path__ + "static/screenshot-iphone12-one-afb7a300779af0b1e7990cb147901328.png";